<div class="fancy-hero-one coutom_header">
    <div class="container">
      <div class="row">
        <div class="col-lg-12 m-auto hdr_with_btn">
          <a class="back_wrap" routerLink="/home"><img src="assets/images/assets/back.png" alt="Back" title="Back" /></a>
          <h3 class="font-rubik">{{name}} ({{mobile_no}})</h3> 
          <a class="logout_wrap" (click)="logout()"><img  src="assets/images/assets/logout.png" alt="Logout" title="Logout" /></a>
          <button class="hdr_btn theme-btn-six" [routerLink]="['/register-property']">Add New Asset</button>
        </div>
      </div>
    </div>
  </div>

  <div class="coutom_two">
    <div class="container">
      <div class="row">
        <div class="col-lg-12 m-auto hdr_with_btn">
          <!-- <div class="page-title">Contact us</div> -->
          <h2 class="font-rubik">Asset List</h2> 
        </div>
      </div>
    </div>
  </div>

  <div class="hero-banner-one contact-us-light">
    <div class="container">

        <div class="pt-50 pb-50">
          <div class="table_wrap">
            <div *ngIf="property_list.length <= 0" class="no_data">No Asset added</div>
            
            <table *ngIf="property_list.length > 0" class="table table_design">
              <thead>
                <tr>
                  <th scope="col">Asset ID</th>
                  <th scope="col">Asset Type</th>
                  <!-- <th scope="col">Name of Household</th> -->
                  <th scope="col">Address</th>
                  <th scope="col">Ward</th>
                  <th class="text-center" scope="col">Payment Detail</th>
                  <th class="text-center" scope="col">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let data of property_list; index as i">
                  <td scope="row" *ngIf="data?.property_uid != 0">{{ data?.property_uid }}</td>
                  <td scope="row" *ngIf="data?.property_uid == 0">Pending Approval</td>
                  <td scope="row">{{ data?.property_type?.type_name }}</td>
                  <!-- <td>
                    {{ data?.consumer?.name }}
                  </td> -->
                  <td>{{ data?.consumer?.address}}</td>
                  <td>{{ data?.region?.region_name}}</td>
                  <td class="text-center" style="vertical-align: middle;">
                    <a title="Payment Detail"  [ngClass]="{'disabled': data?.is_approved == false}" [routerLink]="['/payment-detail', data?.id]" class="pay_btn">
                      <img src="assets/images/assets/pay_detail.png" />
                    </a>
                  </td>
                  <td>
                    <button matTooltip="View Bill" [ngClass]="{'disabled': data?.is_approved == false}" 
                    [routerLink]="['/user-property-detail', data?.id]" class="theme-btn-one">Bill</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
  </div>
  </div>
  
  